<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="学校名" prop="schoolName">
        <el-input v-model.trim="dataForm.schoolName" placeholder="学校名"></el-input>
      </el-form-item>
      <el-form-item label="学校代码" prop="schoolCode">
        <el-input v-model.trim="dataForm.schoolCode" placeholder="学校代码"></el-input>
      </el-form-item>
      <el-form-item label="校长" prop="principal">
        <el-input v-model.trim="dataForm.principal" placeholder="校长"></el-input>
      </el-form-item>
      <el-form-item label="校长电话" prop="principalPhone">
        <el-input v-model.trim="dataForm.principalPhone" placeholder="校长联系方式"></el-input>
      </el-form-item>
      <el-form-item label="省市县" prop="selectArea">
        <!--<el-cascader style="width: 300px" v-model="cityList" @change="getCity" :options="city"></el-cascader>
        <el-input v-model.trim="city[cityList]" ></el-input>-->
        <el-select v-model="dataForm.selectProvince" filterable size="small" @change="selectProvinceFun($event)" placeholder="请选择省份">
          <el-option value="" label="请选择省份"></el-option>
          <el-option :value="item" :label="item.label" v-for="(item, index) in city" :key="index"></el-option>
        </el-select>
        <el-select v-model="dataForm.selectCity" filterable size="small" @change="selectCityFun($event)" placeholder="请选择城市">
          <el-option value="" label="请选择城市"></el-option>
          <el-option :value="item" :label="item.label" v-for="(item, index) in cityList" :key="index"></el-option>
        </el-select>
        <el-select v-model="dataForm.selectArea" filterable size="small" @change="selectAreaFun($event)" placeholder="请选择区县">
          <el-option value="" label="请选择区县"></el-option>
          <el-option :value="item" :label="item.label" v-for="(item, index) in areaList" :key="index"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="前端首页标题" prop="frontSchoolName">
        <el-input v-model.trim="dataForm.frontSchoolName" placeholder="输入标题名称"></el-input>
      </el-form-item>
      <el-form-item label="移动端首页图片" prop="remark">
        <el-upload
                class="avatar-uploader"
                :action="uploadUrl"
                :show-file-list="false"
                :on-success="uploadSuccessHandle"
                :before-upload="uploadBeforeUploadHandle">
          <img v-if="dataForm.frontSchoolImg" :src="dataForm.frontSchoolImg" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <el-button type="primary" @click="removeImg ()">删除图片</el-button>

      </el-form-item>
      <el-form-item label="学校logo" prop="remark">
        <el-upload
                class="avatar-uploader"
                :action="uploadLogoUrl"
                :show-file-list="false"
                :on-success="uploadLogSuccessHandle"
                :before-upload="uploadLogBeforeUploadHandle">
          <img v-if="dataForm.schoolLogoImg" :src="dataForm.schoolLogoImg" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <el-button type="primary" @click="removeLogImg ()">删除图片</el-button>
      </el-form-item>

      <!--<el-form-item label="省市县" prop="selectArea">
              <el-select v-model="dataForm.selectCity" filterable size="small" @change="selectCityFun($event)" placeholder="请选择城市">
                <el-option value="" label="请选择城市"></el-option>
                <el-option :value="item" :label="item.label" v-for="(item, index) in cityList" :key="index"></el-option>
              </el-select>
      </el-form-item>
      <el-form-item label="省市县" prop="selectArea">
              <el-select v-model="dataForm.selectArea" filterable size="small" @change="selectAreaFun($event)" placeholder="请选择区县">
                <el-option value="" label="请选择区县"></el-option>
                <el-option :value="item" :label="item.label" v-for="(item, index) in areaList" :key="index"></el-option>
              </el-select>
      </el-form-item>-->
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import city from '@/assets/json/city.json'
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      uploadUrl: '',
      uploadLogoUrl: '',
      visible: false,
      // 整个省市县数据
      city: city,
      // 被选中的市数据
      cityList: [],
      // 被选中的县数据
      areaList: [],
      selectProvince: {},
      selectCity: {},
      selectArea: {},
      dataForm: {
        id: '',
        schoolName: '',
        schoolCode: '',
        principal: '',
        principalPhone: '',
        province: '',
        city: '',
        area: '',
        selectProvince: {},
        selectCity: {},
        selectArea: {},
        frontSchoolName: '',
        frontSchoolImg: '',
        schoolLogoImg: ''
      }
    }
  },
  watch: {
    'dataForm.selectProvince': { // 子级下拉框的监听对象
      deep: true,
      handler: function (newval) { // 监听内容如下
        console.log(this.city)
        this.city.forEach(city => {
          if (city.value === newval.value) {
            newval.children = city.children
          }
        })
        console.log(this.newval)
        this.selectProvinceFun(newval)// 值改变后的事件处理
      }
    },
    'dataForm.selectCity': { // 子级下拉框的监听对象
      deep: true,
      handler: function (newval) { // 监听内容如下
        console.log(this.cityList)
        this.cityList.forEach(city => {
          if (city.value === newval.value) {
            newval.children = city.children
          }
        })
        console.log(this.newval)
        this.selectCityFun(newval)// 值改变后的事件处理
      }
    }
  },
  computed: {
    dataRule () {
      return {
        schoolName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        schoolCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    getCity () {
      console.log(this.cityList)
    },
    init () {
      console.log('运行')
      this.visible = true
      this.uploadUrl = `${window.SITE_CONFIG.apiURL}/sys/oss/upload?token=${Cookies.get('token')}`
      this.uploadLogoUrl = `${window.SITE_CONFIG.apiURL}/sys/oss/upload?token=${Cookies.get('token')}`
      console.log(this.city)
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 省份 市 县联动
    selectProvinceFun (event) {
      console.log(event)
      console.log(1111111111)
      if (event) {
        this.cityList = event.children
      } else {
        this.cityList = []
      }
      this.areaList = []
      this.$emit('getLawyerListInfo', [event.name, 'province'])
    },
    selectCityFun (event) {
      console.log(event)
      if (event) {
        this.areaList = event.children
      } else {
        this.areaList = []
      }
      this.$emit('getLawyerListInfo', [event.name, 'city'])
    },
    selectAreaFun (event) {
      console.log(event)
      this.$emit('getLawyerListInfo', [event.name, 'area'])
    },
    // 获取信息
    getInfo () {
      this.$http.get('/school/school/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        console.log(this.dataForm)
      }).catch(() => {})
    },
    // 上传图片之前
    uploadBeforeUploadHandle (file) {
      if (file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/gif') {
        this.$message.error(this.$t('upload.tip', { format: 'jpg、png、gif' }))
        return false
      }
    },
    // 上传图片之前
    uploadLogBeforeUploadHandle(file){
      if (file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/gif') {
        this.$message.error(this.$t('upload.tip', { format: 'jpg、png、gif' }))
        return false
      }
    },
    //删除图片
    removeImg () {
      this.dataForm.frontSchoolImg = ''
      console.log(this.frontSchoolImg+'++++++++++')
    },
    //删除图片
    removeLogImg(){
      this.dataForm.schoolLogoImg = ''
      console.log(this.schoolLogoImg+'++++++++++')
    },
    // 上传图片成功
    uploadSuccessHandle (res, file, fileList) {
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      this.dataForm.frontSchoolImg = res.data.src
    },
    // 上传图片成功
    uploadLogSuccessHandle(res, file, fileList){
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      this.dataForm.schoolLogoImg = res.data.src
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/school/school/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { leading: true, trailing: false })
  }
}
</script>
